module.exports = __webpack_public_path__ + "media/images/front/icon_02_search_y-e27e4a7a6816ebf4f6e51ed49659fd32.png";